import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=c2a9b386&scoped=true"
import script from "./grade.vue?vue&type=script&lang=js"
export * from "./grade.vue?vue&type=script&lang=js"
import style0 from "./grade.vue?vue&type=style&index=0&id=c2a9b386&prod&lang=less&scoped=true"
import style1 from "./grade.vue?vue&type=style&index=1&id=c2a9b386&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9b386",
  null
  
)

export default component.exports